import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import { LoginRequest } from './login.types';

export const requestLogin = createAction<SagaPayload<LoginRequest>['payload']>('request/login');
